<template>
    <div class="component making-our-brand-tangible-slider section" data-shape-id="howItComesToLifeSlider">
        <particles :particles="particles" ref="particles" />
        <div class="slider-brand" ref="slider" v-touch:swipe.left="swipeHandler" v-touch:swipe.right="swipeHandler">
            <making-our-brand-tangible-opener
                data-slide-id="1"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 1 }"
                data-shape="howItComesToLifeSlider"
            />
            <making-our-brand-tangible-section
                data-slide-id="2"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 2 }"
                v-bind="makingOurBrandTangibleSections.visualDesign"
                ref="visual-design"
                data-shape="visualDesign"
            />
            <making-our-brand-tangible-section
                data-slide-id="3"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 3 }"
                v-bind="makingOurBrandTangibleSections.audioIdentity"
                ref="audio-identity"
                data-shape="audioIdentity"
            />
            <making-our-brand-tangible-section
                data-slide-id="4"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 4 }"
                v-bind="makingOurBrandTangibleSections.typeface"
                ref="typeface"
                data-shape="typeface"
            />
            <making-our-brand-tangible-arcase
                data-slide-id="5"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 5 }"
                data-shape="visualDesign"
            />
            <making-our-brand-tangible-design-system
                data-slide-id="6"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 6 }"
                data-shape="joyAndTogetherness"
            />
            <!--
            <how-it-comes-to-life-slider
                data-slide-id="7"
                class="slider-brand-slide"
                :class="{ active: activeSlide === 7 }"
                ref="howItComesToLifeSlider"
                data-shape="howItComesToLifeSlider"
            />
            -->

            <div class="slider-dots-container">
                <div class="slider-dots" :class="{ 'color-scheme-inverted': activeSlide === 0 }">
                    <div class="dot" @click="goToSlide(1)" :class="{ active: activeSlide === 1 }"></div>
                    <div class="dot" @click="goToSlide(2)" :class="{ active: activeSlide === 2 }"></div>
                    <div class="dot" @click="goToSlide(3)" :class="{ active: activeSlide === 3 }"></div>
                    <div class="dot" @click="goToSlide(4)" :class="{ active: activeSlide === 4 }"></div>
                    <div class="dot" @click="goToSlide(5)" :class="{ active: activeSlide === 5 }"></div>
                    <div class="dot" @click="goToSlide(6)" :class="{ active: activeSlide === 6 }"></div>
                </div>
            </div>
            <div
                v-show="!hasTouchSupport"
                data-cursor-state="arrow-left"
                class="custom-cursor-trigger-zone cc-arrow-left"
                :class="{ 'is-hidden': activeSlide === 1, 'has-full-width': activeSlide === 6 }"
                @click="goToPreviousSlide"
            ></div>
            <div
                v-show="!hasTouchSupport"
                data-cursor-state="arrow-right"
                class="custom-cursor-trigger-zone cc-arrow-right"
                :class="{ 'is-hidden': activeSlide === 6, 'has-full-width': activeSlide === 1 }"
                @click="goToNextSlide"
            ></div>
        </div>
    </div>
</template>

<script>
    import Particles from '../../Particles.vue';
    import MakingOurBrandTangibleOpener from './MakingOurBrandTangibleOpener.vue';
    import MakingOurBrandTangibleSection from './MakingOurBrandTangibleSection.vue';
    import MakingOurBrandTangibleArcase from './MakingOurBrandTangibleArcase.vue';
    import MakingOurBrandTangibleDesignSystem from './MakingOurBrandTangibleDesignSystem.vue';
    //import HowItComesToLifeSlider from './HowItComesToLifeSlider.vue';

    export default {
        name: 'MakingOurBrandTangibleSlider',
        components: {
            Particles,
            MakingOurBrandTangibleOpener,
            MakingOurBrandTangibleSection,
            MakingOurBrandTangibleArcase,
            MakingOurBrandTangibleDesignSystem,
            /*HowItComesToLifeSlider,*/
        },
        data() {
            return {
                activeSlide: 1,
                particles: [
                    {
                        shape: 'parallelogram',
                        color: 'magenta',
                        size: 'l',
                        top: 20,
                        left: -2,
                    },
                    {
                        shape: 'circle',
                        color: 'magenta',
                        size: 'l',
                        top: 70,
                        left: 5,
                    },
                    {
                        shape: 'parallelogram',
                        color: 'wild-blue-yonder',
                        top: 35,
                        right: 10,
                    },
                    {
                        shape: 'parallelogram',
                        color: 'wild-blue-yonder',
                        top: 75,
                        size: 's',
                        left: 4,
                    },
                ],
                makingOurBrandTangibleSections: {
                    visualDesign: {
                        headline: 'Visual Design',
                        copy:
                            'Our Liquid Brand Design system is built around our corporate color Magenta. It ensures strong recognition while enabling creative flexibility.',
                        vimeoId: 453641291,
                        vimeoCoverImg: 'video-cover-visual-design',
                        shapeId: 'visualDesign',
                        sectionName: 'visual-design',
                    },
                    audioIdentity: {
                        headline: 'Audio Identity',
                        copy:
                            'From our iconic sound logo to functional sounds to guidance for voice interactions – our holistic approach to audio branding includes everything you need to be heard.',
                        vimeoId: 465762450,
                        vimeoCoverImg: 'video-cover-audio-identity',
                        shapeId: 'audioIdentity',
                        sectionName: 'audio-identity',
                    },
                    /*
                    arcase: {
                        headline: 'AUGMENTED REALITY',
                        copy:
                            'Brands need to continuously reinvent themselves in order to stay relevant to their customers. Leveraging new touchpoints and technologies like Augmented and Virtual Reality is just one way of achieving this.',
                        vimeoId: 475520510,
                        vimeoCoverImg: 'video-cover-typeface',
                        shapeId: 'typeface',
                        sectionName: 'typeface',
                    },
                    */
                    typeface: {
                        headline: 'Typeface',
                        copy:
                            'Our typeface »TeleNeo« was exclusively designed for Deutsche Telekom. It plays an important role in creating a distinctive and recognizable look for our brand.',
                        vimeoId: 475520510,
                        vimeoCoverImg: 'video-cover-typeface',
                        shapeId: 'typeface',
                        sectionName: 'typeface',
                    },
                },
            };
        },
        methods: {
            goToSlide(id) {
                this.handleSlideChange(id);
            },
            handleSlideChange(id) {
                let activeSlide = document.querySelector('.slider-brand-slide.active');
                activeSlide.classList.add('on-leave');

                //activeSlide.setActive();

                setTimeout(() => {
                    activeSlide.classList.remove('on-leave');
                    this.activeSlide = id;

                    this.$store.dispatch(
                        'updateBackgroundShape',
                        document.querySelector('[data-slide-id="' + this.activeSlide + '"]').getAttribute('data-shape')
                    );
                    //this.$refs.particles.resetParticleColor();
                }, 200);
            },
            goToNextSlide() {
                if (this.activeSlide < 6) {
                    let nextSlide = this.activeSlide + 1;
                    this.handleSlideChange(nextSlide);
                }
            },
            goToPreviousSlide() {
                if (this.activeSlide > 1) {
                    let previousSlide = this.activeSlide - 1;
                    this.handleSlideChange(previousSlide);
                }
            },
            swipeHandler(direction) {
                if (direction === 'left') {
                    this.goToNextSlide();
                }

                if (direction === 'right') {
                    this.goToPreviousSlide();
                }
            },
            resetSlider() {
                this.activeSlide = 1;
                this.$refs.particles.resetParticleColor();
            },
        },
        computed: {
            hasTouchSupport() {
                return this.$store.getters.hasTouchSupport;
            },
        },
    };
</script>

<style scoped lang="scss">
    .component {
        position: relative;
        width: 100%;
    }

    .section-opener {
        color: #ffffff;
        margin: 0 auto;
    }

    .shape {
        display: none;
        position: absolute;
        width: 80vw;
        left: 10vw;
        top: 0;
    }

    .slider-brand {
        width: 100%;
        height: 80vh;
        position: relative;
        @include flex($justify-content: center);

        @media (max-width: breakpoint('medium')) {
            height: 90vh;
        }

        .slider-brand-slide {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;

            .message-client {
                @media (max-width: breakpoint('medium')) {
                    margin-bottom: spacing(5);
                }
            }

            &.on-leave {
                .message-client,
                .message-telekom {
                    animation: anim-fade-out 0.3s 0s !important;
                }

                @keyframes anim-fade-out {
                    from {
                        transform: translateY(0px);
                        opacity: 1;
                    }

                    to {
                        transform: translateY(15px);
                        opacity: 0;
                    }
                }
            }

            &.active {
                @include flex($align-items: center);

                .message-client {
                    animation: anim-fade-in 0.75s 0.1s forwards;
                }

                .message-telekom {
                    animation: anim-fade-in 0.75s 0.25s forwards;
                }

                @keyframes anim-fade-in {
                    from {
                        transform: translateY(15px);
                        opacity: 0;
                    }

                    to {
                        transform: translateY(0px);
                        opacity: 1;
                    }
                }
            }

            &:nth-of-type(2) {
                .message-client {
                    .sender-image,
                    .message-copy {
                        background-color: color('wedgewood');
                    }

                    .message-copy:after {
                        border-left-color: color('wedgewood');
                    }
                }

                .message .message-copy .sender-name {
                    display: block;
                }
            }

            &:nth-of-type(3) {
                .message-client {
                    .sender-image,
                    .message-copy {
                        background-color: color('wild-blue-yonder');
                    }
                    .message-copy:after {
                        border-left-color: color('wild-blue-yonder');
                    }
                }
            }

            &:nth-of-type(4) {
                .message-client {
                    .sender-image,
                    .message-copy {
                        background-color: color('half-baked');
                    }
                    .message-copy:after {
                        border-left-color: color('half-baked');
                    }
                }
            }

            &:nth-of-type(5) {
                .message-client {
                    .sender-image,
                    .message-copy {
                        background-color: color('wedgewood');
                    }
                    .message-copy:after {
                        border-left-color: color('wedgewood');
                    }
                }
            }
        }

        .slider-dots-container {
            position: absolute;
            width: 100%;
            bottom: 20px;
            left: 0;
            z-index: 1;
            @include flex($justify-content: center);
        }

        .slider-dots {
            .dot {
                display: inline-block;
                width: 7px;
                height: 7px;
                border-radius: 50%;
                border: 1px solid #000;
                cursor: pointer;
                margin: 0 15px;

                &.active {
                    border-color: color('magenta');
                    background-color: color('magenta');
                }
            }

            &.color-scheme-inverted {
                .dot {
                    border: 1px solid #ffffff;

                    &.active {
                        border-color: #ffffff;
                        background-color: #ffffff;
                    }
                }
            }
        }

        .custom-cursor-trigger-zone {
            position: absolute;
            height: 100%;
            width: 25%;

            &.is-hidden {
                width: 0;
            }

            &.cc-arrow-left {
                left: 0;
            }

            &.cc-arrow-right {
                right: 0;
            }

            &.has-full-width {
                //width: 100%;
                width: 25%;
            }
        }

        .slide-illustration {
            opacity: 0;
        }

        .message {
            @include flex($align-items: flex-end);
            opacity: 0;

            .sender-image,
            .message-copy {
                border-radius: 6px;
                box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.25);
            }

            .sender-image {
                position: relative;
                width: 100px;
                height: 100px;

                img {
                    @include reset-img();
                    border-radius: 6px;
                }

                @media (max-width: 660px) {
                    width: 60px;
                    height: 60px;
                }

                @media (max-width: breakpoint('small')) {
                    display: none !important;
                }
            }

            .message-copy {
                width: 250px;
                padding: 30px;
                color: #ffffff;
                margin: 0px spacing(3) 80px spacing(3);
                position: relative;

                @media (max-width: breakpoint('small')) {
                    width: calc(100% - 100px);
                    margin: 0;
                    padding: 20px;
                }

                &:after {
                    position: absolute;
                    bottom: -30px;
                    left: 0;
                    content: '';
                    width: 0;
                    height: 0;
                    border-top: 30px solid transparent;
                    border-left: 30px solid color('wedgewood');
                    border-bottom: 30px solid transparent;

                    @media (max-width: breakpoint('small')) {
                        border-width: 20px !important;
                        bottom: -20px;
                    }
                }

                .sender-name {
                    text-transform: uppercase;
                    font-weight: font-weight('extra-bold');
                    margin-bottom: spacing(1);
                    font-size: 18px;
                    display: none;

                    @media (max-width: breakpoint('small')) {
                        display: block;
                    }
                }

                .sender-message {
                    font-size: 16px;
                }
            }

            &-telekom {
                flex-direction: row-reverse;

                .sender-image,
                .message-copy {
                    background-color: color('magenta');
                }

                .sender-image {
                    img {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 50%;
                        border-radius: 0px;
                    }
                }

                .message-copy:after {
                    border-left: 0px;
                    border-right: 30px solid color('magenta');
                    left: auto;
                    right: 0;
                }
            }
        }
    }
</style>
